// third party imports
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// internal rebet imports
import './stylesEditAdmin.css'
import { 
  EVERYONE_ROUTES,
  ADMIN_ROUTES,
  USER_ROUTES,
  KPI_ROUTES 
} from '../../../utils/Constants';
import { API_ROUTES, SLASHLESS_API_ROUTES } from '../../../api/ApiRoutes';
import createPrivateAdminPanelInstance from '../../../api/PrivateAdminPanelInstance';
import { handleExpiredTokenError } from '../../../utils/ErrorUtils';
import { ADMIN_TYPES } from '../../../utils/Constants';

// component imports
import CheckBox from '../../CommonComponents/CheckBox/CheckBox';
import RebetLoader from '../../CommonComponents/RebetLoader/RebetLoader';
import DropDown from '../../CommonComponents/DropDown/DropDown';

const dropdownOptions = {
  "customer-support": "Customer Support",
  "super-admin-v2": "Super Admin",
  "compliance-agent": "Compliance",
};

const dropdownOptionsENUM = {
  "Customer Support": "customer-support",
  "Super Admin": "super-admin-v2",
  "Compliance": "compliance-agent",
};


const EditAdmin = () => {
  // non-state variables
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem('token'));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(token?.IdToken)

  // state variables
  const [allAdmins, setAllAdmins] = useState([])
  const [dropDownOptions, setDropDownOptions] = useState("")
  const [selectedAdminName, setSelectedAdminName] = useState("")
  const [selectedAdmin, setSelectedAdmin] = useState({})
  const [isApiSending, setIsApiSending] = useState(false)
  const [lastApiCallError, setLastApiCallError] = useState(false)
  const [lastApiErrorMessage, setLastApiErrorMessage] = useState("")
  const [lastApiCallSuccess, setLastApiCallSuccess] = useState(false)
  const [lastApiCallSuccessMessage, setLastApiCallSuccessMessage] = useState("")
  const [submitButtonActive, setSubmitButtonActive] = useState(false)
  const [selectedAdminType, setSelectedAdminType] = useState("");

  // use effects
  useEffect(() => {
    getAllAdmins()
  }, [])

  useEffect(() => {
    if (allAdmins.length === 0 || selectedAdminName === "") return;

    const selectedAdmin = allAdmins?.find(admin => admin?.admin_name === selectedAdminName)
    setSelectedAdminType(dropdownOptions[selectedAdmin.group_name])
    
    setSelectedAdmin(selectedAdmin)
  }, [selectedAdminName, allAdmins])

  useEffect(() => {

    if (selectedAdmin && selectedAdminType) {
      setSubmitButtonActive(true)
    } else {
      setSubmitButtonActive(false)
    }

  }, [selectedAdmin, selectedAdminType])

  // api functions
  const updateAdminPermissions = async () => {

    setIsApiSending(true)
    setLastApiCallError(false)
    setLastApiErrorMessage("")
    setLastApiCallSuccess(false)
    setLastApiCallSuccessMessage("")
    
    const params = {
      admin_id: selectedAdmin?.admin_id,
      group_name: dropdownOptionsENUM[selectedAdminType]
    }

    try {

      await PrivateAdminPanelInstance?.post(API_ROUTES?.EDIT_ADMIN, params)

      setLastApiCallSuccess(true)
      setLastApiCallSuccessMessage("Admin edited successfully!")
      setIsApiSending(false)

      getAllAdmins()

    } catch (error) {
      console.log("error creating admin", error?.resposne)
      setIsApiSending(false)
      setLastApiCallError(true)
      setLastApiErrorMessage(error?.response?.data?.message)
      handleExpiredTokenError(navigate, error?.response)
    }
  
  }

  const getAllAdmins = async () => {
    
    try {

      const response = await PrivateAdminPanelInstance?.post(API_ROUTES?.GET_ADMINS)

      setAllAdmins(response?.data?.data)

      const temp_admin_dict = response?.data?.data.reduce((dict, admin) => {
        dict[admin?.admin_id] = admin?.admin_name;
        return dict;
      }, {});

      setDropDownOptions(temp_admin_dict)

    } catch (error) {
      console.log("error fetching admins", error?.reponse)
    }

  }

  // helper functions
  const handleSetSelectedAdmin = (value) => {
    setSelectedAdminName(value)
  }

  const handleEditAdminPressed = () => {
    if (submitButtonActive) {
      updateAdminPermissions()
    }
  }

  return (
    <div className="edit-admin">

      <div className='edit-admin-header-text'>
        Edit Admin
      </div>

      <div className="admin-permissions-row column">
        <div className="admin-permissions-row column">
          <span className="admin-permissions-label">Agent Name</span>
          <div className='edit-admin-drop-down-container'>
            <DropDown 
              drop_down_options={dropDownOptions}
              selected_value={selectedAdminName}
              set_selected_value={handleSetSelectedAdmin}
            />
          </div>
        </div>
        <div className="admin-permissions-row column">
          <span className="admin-permissions-label">Agent Status</span>
          <DropDown
            drop_down_options={dropdownOptions}
            selected_value={selectedAdminType}
            set_selected_value={setSelectedAdminType}
            custom_placeholder="Agent Status"
          />
        </div>
      </div>
      
      <div className='create-admin-button-container'>
          <button 
            className={
              submitButtonActive ? 'submit-button' : 'submit-button-inactive'
            }
            onClick={handleEditAdminPressed}
          >
            {
              isApiSending
              ? (
                <RebetLoader 
                height={'50px'}
                width={'50px'}
                />
              )
              : "Update Permissions"
            }
          </button>

          {
            lastApiCallError 
              ? (
                <div className='error-message'>
                  {lastApiErrorMessage}
                </div>
              ) 
              : null
            }

            {
              lastApiCallSuccess 
              ? (
                <div className='success-message'>
                  {lastApiCallSuccessMessage}
                </div>
              ) 
              : null
          }


      </div>
      
    </div>
  );
};

export default EditAdmin;